
import { Component, Vue } from 'vue-property-decorator'
import { NavBar, MenuBar } from '@/components'
import FetchWrapper from '@/classes/fetchWrapper'

@Component({
  components: {
    MenuBar,
    NavBar
  }
})
export default class TaskFreeWritingView extends Vue {
  data () {
    return {
      isLoading: false,
      taskId: null,
      remainTime: '',
      disabled: true,
      taskData: null,
      words: [],
      content: ''
    }
  }

  mounted () {
    this.taskId = this.$route.params.taskId
    this.getTaskData()
  }

  fillRemainTime (due) {
    if (due) {
      var now = new Date()
      var days = (due.valueOf() - now.valueOf()) / (1000 * 3600 * 24)
      if (days <= 0) {
        this.remainTime = 'Expired'
      } else {
        var hours = (days - Math.floor(days)) * 24
        var mins = 0
        if ((hours - Math.floor(hours)) > 0) {
          mins = (hours - Math.floor(hours)) * 60
        }
        var daysString = days < 10 ? days < 1 ? '' : `0${Math.floor(days)} Days and ` : `${Math.floor(days)} Days and `
        var hoursString = hours < 10 ? `0${Math.floor(hours)}` : Math.floor(hours)
        var minsString = mins < 10 ? `0${Math.floor(mins)}` : Math.floor(mins)

        this.remainTime = `${daysString}${hoursString}:${minsString} h `
      }
    } else {
      this.remainTime = ''
    }
  }

  displayModalFinish () {
    this.$buefy.dialog.confirm({
      title: 'Are you sure?',
      message: 'By confirming, you won`t be able to change it back.',
      onConfirm: () => {
        this.finish()
      },
      canCancel: true
    })
  }

  async save () {
    await this.updateOnServer(false)
  }

  async finish () {
    await this.updateOnServer(true)
  }

  async getTaskData () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getFreeWritingTaskData${this.taskId ? '/' + this.taskId : ''}`))
      this.taskData = JSON.parse(resp.data)
      this.words = this.taskData.dicionarios
      this.content = this.taskData.content
      this.disabled = resp.completed || new Date(resp.due) <= new Date()
      this.fillRemainTime(new Date(resp.due))
      if (!this.taskId) {
        this.taskId = resp.id
      }
      this.isLoading = false
    } catch (e) {
      this.taskData = null
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not get task data. ${e}`,
        canCancel: false
      })
    }
  }

  async updateOnServer (completed) {
    this.isLoading = true
    var data = {
      content: this.content
    }
    try {
      const resp = await FetchWrapper.post(
        `${process.env.VUE_APP_SERVERURL}/updateFreeWritingTaskData`,
        { data: data, id: Number(this.taskId), completed }
      )
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Success',
        message: 'Task saved Successfully',
        onConfirm: () => {
          if (completed) {
            window.location.href = '/home/tasks'
          }
        },
        canCancel: false
      })
    } catch (e) {
      this.taskData = null
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not save task data. ${e}`,
        canCancel: false
      })
    }
  }
}
